import React from 'react'
import { Badge, IconButton, Tooltip, useTheme } from '@mui/material'
import FilterListIcon from '@mui/icons-material/FilterList'
import ClearIcon from '@mui/icons-material/Clear'

const ResetFiltersButton = ({ filterModel, handleClearFilters }) => {
  const theme = useTheme()
  const isFilterActive =
    filterModel &&
    ((filterModel.items && filterModel.items.length > 0) ||
      (filterModel.quickFilterValues && filterModel.quickFilterValues.length > 0))
      ? true
      : false
  const isNoFilterActive = filterModel.items && filterModel.items.length === 0
  return (
    <Tooltip title={isFilterActive ? 'Clear Filters' : isNoFilterActive ? 'Reset to default' : 'Clear Filters'}>
      <IconButton
        sx={{
          color: theme.palette.text.primary,
          fontWeight: isFilterActive ? 'bold' : '',
          borderRadius: '0px',
        }}
        disabled={
          (filterModel &&
            ((filterModel.items && filterModel.items.length > 0) ||
              (filterModel.quickFilterValues && filterModel.quickFilterValues.length > 0))) ||
          isNoFilterActive
            ? false
            : true
        }
        onClick={handleClearFilters}
      >
        <Badge
          badgeContent={
            <ClearIcon
              sx={{
                fontSize: '18px',
                color: isFilterActive
                  ? theme.palette.text.error
                  : isNoFilterActive
                  ? theme.palette.text.highlight
                  : theme.palette.text.secondary,
              }}
            />
          }
          color="default"
        >
          <FilterListIcon
            sx={{
              fontSize: '30px',
              color: isFilterActive || isNoFilterActive ? theme.palette.text.primary : theme.palette.text.secondary, // Active filters color
            }}
          />
        </Badge>
      </IconButton>
    </Tooltip>
  )
}

export default ResetFiltersButton
